import createIcon from '../../createIcon';

/**
 * @component @name DirectionsRailwayFilled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi41QzggMi41IDQgMyA0IDYuNVYxNkM0IDE3LjkzIDUuNTcgMTkuNSA3LjUgMTkuNUw2IDIwLjVWMjEuNUgxOFYyMC41TDE2LjUgMTkuNUMxOC40MyAxOS41IDIwIDE3LjkzIDIwIDE2VjYuNUMyMCAzIDE2LjQyIDIuNSAxMiAyLjVaTTEyIDE2LjVDMTEuMTcgMTYuNSAxMC41IDE1LjgzIDEwLjUgMTVDMTAuNSAxNC4xNyAxMS4xNyAxMy41IDEyIDEzLjVDMTIuODMgMTMuNSAxMy41IDE0LjE3IDEzLjUgMTVDMTMuNSAxNS44MyAxMi44MyAxNi41IDEyIDE2LjVaTTE4IDEwLjVINlY3LjVIMThWMTAuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsRailwayFilled = createIcon('DirectionsRailwayFilled', [
  [
    'path',
    {
      d: 'M12 2.5C8 2.5 4 3 4 6.5V16C4 17.93 5.57 19.5 7.5 19.5L6 20.5V21.5H18V20.5L16.5 19.5C18.43 19.5 20 17.93 20 16V6.5C20 3 16.42 2.5 12 2.5ZM12 16.5C11.17 16.5 10.5 15.83 10.5 15C10.5 14.17 11.17 13.5 12 13.5C12.83 13.5 13.5 14.17 13.5 15C13.5 15.83 12.83 16.5 12 16.5ZM18 10.5H6V7.5H18V10.5Z',
      key: '1bs6bw',
    },
  ],
]);

export default DirectionsRailwayFilled;
